const ErrorPage = () => {
    return <p>Doesn't work yet... bitch</p>
}

export default ErrorPage;